class DiscountPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeDiscount.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("discount-closed");
    this.subscribed = getCookie("discount-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeDiscount() {
    // ── SIMAX CUSTOM ──
    // Stock passed no expiry → session cookie → popup re-showed every session
    // (and looped on every load inside preview iframes / ITP). Persist for 30 days.
    setCookie("discount-closed", "true", 30);
    // ── END SIMAX CUSTOM ──
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("discount-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("discount-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
        // ── SIMAX CUSTOM ──
        // "Show once, then disable": mark as seen the moment it's shown so it
        // stays hidden for 30 days even if the visitor never clicks Close.
        setCookie("discount-closed", "true", 30);
        // ── END SIMAX CUSTOM ──
      }
    }, this.delay);
  }

  onSubscribe() {
    // ── SIMAX CUSTOM ──
    // Persist subscription for 30 days (was a session cookie).
    setCookie("discount-subscribed", "true", 30);
    // ── END SIMAX CUSTOM ──
    this.hide();
  }
}

customElements.define("discount-popup", DiscountPopup);
